var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankCollect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_collect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9898\\u5E93-\\u5355\\u9009\\u9898",
    transform: "translate(-1150, -254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_collect",
    transform: "translate(1148, 252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993574,2 C11.439958,2 10.9309131,2.30852837 10.6923302,2.79210033 L8.42994815,7.39782601 L3.22593362,8.15693706 C2.69119959,8.23401545 2.24641323,8.59357929 2.0746841,9.0820686 C1.90295494,9.57306433 2.03251964,10.1138781 2.41045231,10.4824651 L6.22413453,14.2177231 L5.33975204,19.3967028 C5.24975674,19.9194227 5.48010187,20.4422141 5.93207832,20.748427 C6.18094631,20.9144237 6.47195494,21 6.76401115,21 C7.00361772,21 7.2447718,20.9422569 7.46328422,20.8288473 L11.9998811,18.432686 L16.5375257,20.8288235 C16.7555143,20.942233 16.9961684,21 17.235275,21 C17.527855,21 17.8188398,20.9143998 18.0677078,20.7484032 C18.5196843,20.4421903 18.7495294,19.9193988 18.6600817,19.396679 L17.7756754,14.2176992 L21.5898576,10.4824412 C21.9672665,10.1135917 22.0973074,9.57304047 21.9250782,9.08204474 C21.7528491,8.59355542 21.3080866,8.23401545 20.7733287,8.1569132 L15.5693142,7.39782601 L13.3069083,2.79210033 C13.0698968,2.30855223 12.5598044,2 11.9993574,2 L11.9993574,2 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#999999",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankCollect);
export default __webpack_public_path__ + "static/media/icon_questionbank_collect.svg";
export { ForwardRef as ReactComponent };